import React, { useState } from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";

const FaQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const arrowStyle = { width: "20px", height: "20px", flexShrink: 0 };

  const faqs = [
    {
      question: " How does WhatsApp Automation help my business?",
      answer:
        " WhatsApp Automation lets you send instant, automated messages to customers, handle queries, and share updates. It saves time, improves engagement, and ensures your messages reach the right people at the right time",
    },

    {
      question: "Can I send promotions to multiple contacts at once?",
      answer:
        " Yes! With Bulk Messaging, you can send updates, promotions, or announcements to many contacts simultaneously. It helps you reach more people quickly while maintaining consistent communication.",
    },

    {
      question:
        "Is WhatsApp Bulk Messaging legal and compliant with WhatsApp terms of service?",
      answer:
        " Absolutely. Using the official WhatsApp Business API and following WhatsApp rules—like getting consent from recipients—keeps your campaigns safe, legal, and spam-free.",
    },

    {
      question: "What types of messages can I automate on WhatsApp?",
      answer:
        " You can automate greetings, order confirmations, payment reminders, and responses to frequently asked questions. Automation helps you stay connected with customers 24/7 without manual effort.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ background: "#bce0faff" }}
    >
      <div className="row mt-4 mb-5">
        <div className="col-lg-3 d-none d-lg-block"></div>
        <div
          className="col-12 col-lg-6 px-3 px-md-4"
          style={{ color: "#A2D8FF" }}
        >
          <h2
            className="text-center mt-5 mb-4"
            style={{ color: "#2F2CD8", fontSize: "2rem", fontWeight: "800" }}
          >
            Frequently Asked Questions
          </h2>

          <div className="row ">
            <div className="col-12 p-3">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <div
                    key={index}
                    onClick={() => toggleFAQ(index)}
                    style={{
                      background: isOpen ? "#ffffff" : "#A2D8FF",
                      borderRadius: "12px",
                      padding: "20px 18px",
                      marginBottom: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "18px",
                          minWidth: "200px",
                          color: isOpen ? "#000000" : "#000000",
                          fontWeight: isOpen ? "500" : "400",
                        }}
                      >
                        {faq.question}
                      </p>

                      {isOpen ? (
                        <FiChevronUp style={arrowStyle} color="#000000" />
                      ) : (
                        <FiChevronDown style={arrowStyle} color="#000000e0" />
                      )}
                    </div>

                    {isOpen && (
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#161616ff",
                          marginTop: "10px",
                          lineHeight: "1.5",
                          // maxWidth: "90%",
                        }}
                      >
                        {faq.answer}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-lg-3 d-none d-lg-block"></div>
      </div>
    </div>
  );
};

export default FaQ;
